export class AccountStandingResultDto {
  category: string;
  ownerCount: number;
  percentage: number;
  title: string;
}
